/*
 * @Author: lixin jiang
 * @Date: 2021-07-07 10:57:29
 * @LastEditTime: 2022-06-10 15:12:45
 * @LastEditors: Yu Wang
 * @Description:
 * @FilePath: \kitchen-online-web\src\aid-base\components\ArcInput\arcInput.jsx
 *
 */

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styles from './arcInput.module.scss';

function ArcInput(props) {
  const {
    defaultValue, type, style, rules, onBlur, styleUnit, unit, onFocus, unitSize, isClearTip,
  } = props;
  const {
    width, height = 40,
  } = style;
  const { pattern, message } = rules;
  const [focus, setFocus] = useState(false);
  const [modified, setModified] = useState(false);
  const [value, setValue] = useState(defaultValue);

  const handleFocusButton = () => {
    onFocus();
    setFocus(true);
  };

  const handleBlurButton = () => {
    setFocus(false);
    setModified(true);
    const status = pattern?.test(value);
    onBlur({
      value,
      validateMessage: status ? '' : message,
    });
  };

  const handleInputChange = (e) => {
    setValue(e.target.value);
  };

  const handleInputFocus = (e) => {
    onFocus(e);
    if (isClearTip) {
      e.target.value = '';
    }
  };

  const handleInputBlur = (e) => {
    if (isClearTip) {
      e.target.value = defaultValue;
    }
  };

  return (
    <div
      className={
        `${styles['arc-input']}
        ${focus && styles['arc-input-focus']}
        ${!focus && modified && styles['arc-input-modified']}
        `
      }
      style={{
        width: `${width}${styleUnit}`,
        height: `${height - 2}${styleUnit}`,
        borderRadius: `${height / 2}${styleUnit}`,
      }}
      onBlur={() => handleBlurButton()}
      onFocus={() => handleFocusButton()}
      aria-hidden
    >
      <input
        type={type}
        defaultValue={value}
        className={styles['arc-input-item']}
        onChange={(e) => handleInputChange(e)}
        style={{ fontSize: '14px', fontWeight: 'bold' }}
        onFocus={(e) => handleInputFocus(e)}
        onBlur={(e) => handleInputBlur(e)}
        placeholder={defaultValue}
      />
      <p className={`${focus && style['arc-focus-unit']}`} style={{ fontSize: unitSize }}>{unit}</p>
    </div>
  );
}

ArcInput.propTypes = {
  defaultValue: PropTypes.number,
  type: PropTypes.string,
  styleUnit: PropTypes.string,
  unit: PropTypes.string,
  unitSize: PropTypes.string,
  rules: PropTypes.objectOf([PropTypes.any]),
  style: PropTypes.objectOf([PropTypes.any]),
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  isClearTip: PropTypes.bool,
};

ArcInput.defaultProps = {
  defaultValue: 0,
  type: 'number',
  style: {},
  rules: {},
  styleUnit: 'rem',
  unit: 'cm',
  unitSize: '14px',
  onBlur: () => {},
  onFocus: () => {},
  isClearTip: false,
};

export default ArcInput;
